// extracted by mini-css-extract-plugin
export default {"subHeader":"SubHeader_subHeader__2ch7B"};